import React, {useCallback} from 'react';
import {Link, Fieldset} from '@flixbus/honeycomb-react';
import {Icon, IconBarGraphSolid} from '@flixbus/honeycomb-icons-react';
import {datadogRum} from '@datadog/browser-rum';
import {PowerBiReportLinkProps} from './PowerBiReportLink.types';

const PowerBiReportLink: React.FC<PowerBiReportLinkProps> = ({
  href,
  page,
  label
}) => {
  const trackLinkClick = useCallback(() => {
    datadogRum.addAction('cpc.powerbi-report-link.clicked', {
      report: `${page}: ${label}`
    });
  }, [page, label]);

  return (
    <Link target="_blank" href={href} onClick={trackLinkClick}>
      <Fieldset itemSpacing="1" horizontal>
        <Icon
          style={{fill: 'currentColor'}}
          InlineIcon={IconBarGraphSolid}
          aria-label="Opens in a New Tab"
        />
        <span>{label}</span>
      </Fieldset>
    </Link>
  );
};

export default React.memo(PowerBiReportLink);
